import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const usePintoSchedule = (packageId) => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchedules = async () => {
      if (!packageId) {
        setSchedules([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const { data, error: err } = await supabase
          .from('erp_member_meal_schedules')
          .select(`
            id,
            delivery_date,
            meal_type,
            quantity,
            kitchen_status,
            is_extra_order,
            meal_order_type,
            menu_items (
              name,
              category,
              calories,
              protein,
              carbs,
              fat
            )
          `)
          .eq('package_id', packageId)
          .order('delivery_date', { ascending: false });

        if (err) throw err;
        setSchedules(data || []);
      } catch (err) {
        console.error('Fetch schedule error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedules();
  }, [packageId]);

  return { schedules, loading, error };
};
